import React, { FormEvent, useEffect, useRef } from "react";
import { useChat } from "./aiContext";

export default function QuestionField() {

    const textareaRef = useRef(null);

    // context
    const { 
        aiContent,
        questionValue,
        setQuestionValue,
        aiModalState,
        currentConversation,
        loading,
        setLoading,
        handleSend,
        startNewChat,
    } = useChat();

    const [queryPlaceHolder, setQueryPlaceHolder] = React.useState<string>('');
    const [showNonActiveUserPrompt, setShowNonActiveUserPrompt] = React.useState<boolean>(false);
    const [temporarilyHideActiveUserPrompt, setTemporarilyHideActiveUserPrompt] = React.useState<boolean>(false);

    useEffect(()=>{
        adjustTextareaHeight();
    },[questionValue, aiModalState]);

    useEffect(() => {
        if (!!currentConversation) {
            setQueryPlaceHolder(aiContent?.aiSearchFieldPlaceholder_ContinousConversation ?? '');

            if(!aiContent?.isActiveUser){
                setShowNonActiveUserPrompt(true);
            }else{
                setShowNonActiveUserPrompt(false);
            }
        } else {
            setQueryPlaceHolder(aiContent?.aiSearchFieldPlaceholder_NewConversation ?? '');
            setShowNonActiveUserPrompt(false);
        }
    },[aiContent, currentConversation]);

    // when content is fetched
    useEffect(()=>{
        if (!!aiContent) {
            if(!!currentConversation){
                setQueryPlaceHolder(aiContent?.aiSearchFieldPlaceholder_ContinousConversation ?? '');
            } else {
                setQueryPlaceHolder(aiContent?.aiSearchFieldPlaceholder_NewConversation ?? '');
            }
        }
    },[aiContent]);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current as HTMLElement | null;
        if (!!textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            doSubmitQuery();
        }
    };

    function doSubmitQuery(e?: FormEvent){
        if(!!e){
            e.preventDefault();
        }
        if(!!questionValue){
            setQuestionValue("");
            handleSend(questionValue);
        }else{
            console.warn("please create a query first!");
        }
    }

    return (
        <div className="ai-modal__question">
            {(showNonActiveUserPrompt && !temporarilyHideActiveUserPrompt) && <div className="activeUserPrompt">
                <span>Logga in med ett personligt konto för att kunna ställa följdfrågor <a href={aiContent?.loginUrl}>här</a>.
                    Vill du ställa en ny fråga klicka på plus-knappen nedan.</span>
                    <button className="closePrompt" tabIndex={0}
                        onKeyUp={(e) => {e.key === "Enter" && setTemporarilyHideActiveUserPrompt(true)}}
                        onClick={()=>setTemporarilyHideActiveUserPrompt(true)}>
                    </button>
                </div>}
            <div className="ai-modal__question-content">
                <div className="userActionField">
                    
                    <div className="ai-modal__searchfield-container">
                        <form onSubmit={doSubmitQuery} className="submitQuestionForm" >
                            <span className="lengthOfQuery">{questionValue?.length} / 1000</span>
                            <textarea ref={textareaRef} rows={1} style={{ resize: 'none' }}
                                aria-label="ange din sökfråga till ai"
                                maxLength={1000} 
                                onKeyDown={handleKeyDown}
                                disabled={loading || showNonActiveUserPrompt}
                                className="chat-input"
                                placeholder={loading ? "Laddar..." : queryPlaceHolder}
                                value={questionValue}
                                onChange={(e)=> setQuestionValue(e.currentTarget.value)}
                            />
                            {loading && <span className="blocker__loader"/>}
                            <input type="submit" disabled={loading || showNonActiveUserPrompt} value="Submit" className="ai-modal__searchfield-button" onBlur={(e)=>{
                                setTimeout(() => {
if(document.activeElement?.closest("#aibox") === undefined || document.activeElement?.closest("#aibox") === null){
    $("#aibox .menu__list [tabindex]:visible")[0].focus();
                        }
                        }, 1)
                            }} aria-label="skicka din sökfråga"/>
                        </form>
                    </div>
                </div>
                <div className="ai-modal__disclaimer">AI-genererat innehåll kan vara felaktigt</div>
            </div>
        </div>
    );
}